export { TOURNAMENT_START_DATE } from "@shared/config";

export const PICKER_SLUG = "VwidfsQ9uFs-";
export const ADMIN_SLUG = "AaWPoZs0erYd";
